export default __webpack_public_path__ + "static/media/New-My-matches-grey.400e7146.svg";